import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const } from "../../constants.js";
import { Space, message } from 'antd';
import { FilterComponent, FilterButton, PaginationComponent } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq } from "./requests.js";
import { Header } from "antd/es/layout/layout";
import CreateScheduler from "./components/CreateScheduler.jsx";
import UpdateScheduler from "./components/UpdateScheduler.jsx";
import { convertTimeTotz } from "../../../../../wrappers/commonFunctions.js";

const langKey = Const["scheduler"].lngKey;
const headerStyle = { background: 'white', textAlign: "right" }
const IndexScheduler = (props) => {
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [currentPage, setCurrentPage] = useState(1)
  const [filters, setFilters] = useState();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    sortName: "id",
    sortType: "desc",
  });


  const schedulerTypes = [
    {
      "value": "recurring",
      "label": "Recurring"
    },
    {
      "value": "one_time",
      "label": "One Time"
    }
  ]
  const occurEveryTypes = [
    {
      "value": "hour",
      "label": "Hour"
    },
    {
      "value": "minute",
      "label": "Minute"
    }
  ]
  const repeatTypes = [
    {
      "value": "days",
      "label": "days"
    },
    {
      "value": "weeks",
      "label": "weeks"
    }
  ]
  // ==================================
  //   Use States End
  // ==================================

  // ================================== UpdateLocation
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'name',
      title: trans(`${langKey}.name`),
      dataIndex: "name",
    },
    {
      key: 'type',
      title: trans(`${langKey}.type`),
      dataIndex: "type",
    },
    {
      key: 'is_enabled',
      title: trans(`${langKey}.is_enabled`),
      render: (record) => {
        return record.is_enabled ? 'Yes' : 'No'
      }

    },
    {
      key: 'description',
      title: trans(`${langKey}.description`),
      dataIndex: "description",
    },
    // {
    //   key: 'one_time_time',
    //   title: trans(`${langKey}.one_time_time`),
    //   render: (record) => {
    //     const time = record.one_time_time ? convertTimeTotz(record.one_time_time) : null
    //     return time ?
    //       <div>

    //         <small>{ trans(`${langKey}.one_time_time`) } { convertTimeTotz(record.one_time_time).format('hh:mm a') }</small>
    //       </div>
    //       : '--'
    //   }
    // },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onDelete={ onDelete }
          onEdit={ onEdit }
        ></ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters]);

  const getAllData = () => {
    makeRequest(setLoader, getAllDataReq, filters, onSuccess, null);
  };

  const onSuccess = (response) => {
    //setTotalRecords(response.codes.current_page);
    setPagination(response.schedulers);
    setDataSource(response.schedulers.data);
  };

  const onEdit = (record) => {
    setChildComponent(
      <UpdateScheduler onCompleted={ onCompleted } record={ record } disabled={ false } types={ schedulerTypes } occurEveryTypes={ occurEveryTypes } repeatTypes={ repeatTypes } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    //setDataSource(res.codes.data);
    getAllData();
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateScheduler onCompleted={ onCompleted } types={ schedulerTypes } occurEveryTypes={ occurEveryTypes } repeatTypes={ repeatTypes } />);
  };

  const onCompleted = (data) => {
    if (data) {
      getAllData();
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------

  return (
    <>

      { childComponent }
      <BodyComponent>
        <Header style={ headerStyle }>
          <Space>
            <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
            <FilterButton onClick={ onOpenFilter } />
          </Space>

        </Header>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexScheduler;
const filterFields = [
  {
    type: "text",
    placeholder: "Name",
    key: "name"
  },
  {
    type: "text",
    placeholder: "Value",
    key: "value"
  },
]

